import { useEffect } from "react";
import { CheckArabicText, CheckEnglishText } from "../../../utils";
import "./style.css";
import { useTranslation } from "react-i18next";
import { Block, Inline } from "@comp/crRender";

import "../inputsGlobals.css"

const TextArea = ({label,defaultValue = "" ,value,setValue,className = "",lang = "Ar",formHandler,name,isRequired = false, rows = 3,min,max}) => {
  const { t } = useTranslation();
  const { formValues, handleFormValues, errors } = formHandler || {};

  useEffect(() => {
    handleFormValues(name, {
      value: defaultValue || "",
      isRequired,
      isError: false,
      min,
      max,
    }, { markAsTouched: false });
  }, [defaultValue, name, min, max, isRequired]);

  const handleValue = (value) => {
    const valueConfig = { ...formValues[name], value, min, max };

    if (lang == "Ar" || (value == "" && lang != "En")) {
      if (CheckArabicText(value) || value == "") {
        handleFormValues(name, valueConfig);
        setValue?.(value)
      }
    }

    if (lang == "En" || (value == "" && lang != "Ar")) {
      if (CheckEnglishText(value) || value == "") {
        handleFormValues(name, valueConfig);
        setValue?.(value)
      }
    }
    if (lang == "any") {
      handleFormValues(name, valueConfig);
      setValue?.(value)
    }
  };

  return (
    <div  className={`text-container ${className}`}>
      <Block isRender={label} className={"col-sm-12 default-label"}>
        <span> {t(label)} </span>
        <Inline isRender={isRequired} className={"required"}> * </Inline>
      </Block>
      <textarea
        
        rows={rows}
        className={`text-area col-12 ${errors[name]?.isError ? "field-required" : ""}`}
        value={formValues[name]?.value ||value}
        onChange={(e) => handleValue(e.target.value)}
        minLength={min}
        maxLength={max}
      ></textarea>
      <Block isRender={errors[name] && errors[name] != undefined}>
        <p className="error-message">{t(errors[name]?.errorMessage)}</p>
      </Block>
    </div>
  );
};

export default TextArea;
